import { render, staticRenderFns } from "./ModalFormularioProgramaUniversidad.vue?vue&type=template&id=1d2df131&scoped=true"
import script from "./ModalFormularioProgramaUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormularioProgramaUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioProgramaUniversidad.vue?vue&type=style&index=0&id=1d2df131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2df131",
  null
  
)

export default component.exports